import { useLocation, useNavigate } from 'react-router-dom'
import axios from '../api/axios'
import useAuth from './useAuth'
import { useDispatch } from 'react-redux'
import {
    setInitData,
    setLoggedInUser,
} from '../features/security/security.slice'
import { useState } from 'react'

const useRefreshToken = () => {
    const [initiated, setInitiated] = useState<boolean>(false)
    const { setAuth }: any = useAuth()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    const from = location?.pathname || '/'

    const refresh = async (check = false) => {
        await axios
            .get('/auth/refresh-token', {
                withCredentials: true,
            })
            .then((response) => {
                setInitiated(true)

                if (check) {
                    navigate(from)
                }

                if (response?.data.success) {
                    // setTimeout(() => {
                    //     refresh(check)
                    // }, response?.data.data.expires_in * 1000 - 10000)

                    setAuth((prev) => {
                        const accessToken = response?.data?.data.token
                        const user = response?.data?.data.user
                        return { ...prev, accessToken, user }
                    })
                    dispatch(setInitData(response.data?.data?.initData))
                    dispatch(setLoggedInUser(response.data?.data?.user))
                    return response.data.data.token
                } else {
                    setAuth({})
                }
            })
            .catch((err) => {
                if (err?.response?.data?.initiated === false) {
                    setInitiated(false)
                } else {
                    setInitiated(true)
                    setAuth({})
                }
            })
            .finally(() => {
                document.body.classList.remove('with-main-preloader')
            })
    }

    return { refresh, initiated }
}

export default useRefreshToken
